(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-kit-set-configs]";
  const MOBILE_MQ = "(max-width: 720px)";
  /** 与 CSS --kit-set-vw-pc 一致：PC 视口 < 1200px 时冻结缩放基准 */
  const PC_MIN_VW = 1200;

  function pcViewport() {
    return Math.max(window.innerWidth, PC_MIN_VW);
  }

  function contentPadLeft() {
    var vw = pcViewport();
    var contentMax = Math.min((1200 * vw) / 2560, 1200);
    var edge = Math.min((20 * vw) / 2560, 20);
    return Math.max(edge, (window.innerWidth - contentMax) / 2);
  }

  function spaceBetween() {
    return Math.min((32 * pcViewport()) / 2560, 32);
  }

  function destroySwiper(section) {
    if (section.__kitSetConfigsSwiper) {
      section.__kitSetConfigsSwiper.destroy(true, true);
      section.__kitSetConfigsSwiper = null;
    }
  }

  function initSwiper(section) {
    var swiperEl = section.querySelector("[data-configs-swiper]");
    if (!swiperEl || typeof Swiper === "undefined") return;

    destroySwiper(section);

    section.__kitSetConfigsSwiper = new Swiper(swiperEl, {
      slidesPerView: "auto",
      spaceBetween: spaceBetween(),
      slidesOffsetBefore: contentPadLeft(),
      slidesOffsetAfter: Math.min((20 * pcViewport()) / 2560, 20),
      centeredSlides: false,
      initialSlide: 0,
      speed: 500,
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      watchSlidesProgress: true,
      resistanceRatio: 0.65,
    });
  }

  function applyMode(section) {
    var isMobile = window.matchMedia(MOBILE_MQ).matches;

    if (isMobile) {
      destroySwiper(section);
      section.__kitSetConfigsMode = "mobile";
      return;
    }

    if (section.__kitSetConfigsMode !== "desktop" || !section.__kitSetConfigsSwiper) {
      initSwiper(section);
      section.__kitSetConfigsMode = "desktop";
      return;
    }

    section.__kitSetConfigsSwiper.params.spaceBetween = spaceBetween();
    section.__kitSetConfigsSwiper.params.slidesOffsetBefore = contentPadLeft();
    section.__kitSetConfigsSwiper.params.slidesOffsetAfter = Math.min(
      (20 * pcViewport()) / 2560,
      20
    );
    section.__kitSetConfigsSwiper.update();
  }

  function initSection(section) {
    if (!section) return;

    section.__kitSetConfigsMode = null;
    applyMode(section);

    if (!section.__kitSetConfigsResizeBound) {
      section.__kitSetConfigsResizeBound = true;
      var frame = 0;
      window.addEventListener("resize", function () {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          applyMode(section);
        });
      });
    }
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target.querySelector(ROOT_SELECTOR) || event.target.closest(ROOT_SELECTOR));
  });
})();
